import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home,
    children:[
      {
        path: 'NotFound',
        name: 'NotFound',
        component: () => import('../views/404.vue')
      },
      {
        path: 'home/reportparams', name: 'reportparams',
        component: () => import('../reports/report_param')
      },

    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/Users',
    name: 'Users',
    component: () => import('../views/Users.vue')
  },
   
  
  {
    path: '/GenTable',
    name: 'GenTable',
    component: () => import('../views/GenTables.vue')
  },
  {
    path: '/GenTableCustom',
    name: 'GenTableCustom',
    component: () => import('../views/GenTablesCustom.vue')
  },
  {
    path: '/feedtrans',
    name: 'feedtrans',
    component: () => import('../views/feedtrans')
  },
  {
    path: '/list',
    name: 'GenTable',
    component: () => import('../views/list.vue')
  },
  {
    path: '/genform/:menuid',
    name: 'Genform',
    component: () => import('../views/GenForm.vue')
  },
  {
    path: '/genformedit/:menuid/:pkey/:val',
    name: 'Genformedit',
    component: () => import('../views/GenFormEdit.vue')
  },
   
  
 
 
  {
    path: '/report1/:name',
    name: 'report1',
    component: () => import('../reports/report1.vue')
  },
  {
    path: '/report2/:name',
    name: 'report2',
    component: () => import('../reports/reportrrecieve.vue')
  },
  {
    path: '/report3/:name',
    name: 'report4',
    component: () => import('../reports/reportbroken.vue')
  },
  
  {
    path: '/degign/:rptname',
    name: 'degign',
    component: () => import('../reports/design.vue')
  },
  {
    path: '/view/:reportname',
    name: 'view',
    component: () => import('../reports/view.vue')
  },
  {
    path: '/view_dna/:reportname',
    name: 'view_dna',
    component: () => import('../reports/view_dna.vue')
  },
  {
    path: '/printvisa/:code',
    name: 'degign',
    component: () => import('../reports/printvisa.vue')
  },
  {
    path: '/reportparam',
    name: 'reportparam',
    component: () => import('../reports/report_param.vue')
  },
  {
    path: '/reportparams1/:rptname',
    name: 'reportparams1',
    component: () => import('../reports/report_param1.vue')
  },
  {
    path: '/reportparams2',
    name: 'reportparams2',
    component: () => import('../reports/report_param2.vue')
  },
  

  
  {
    path: '/glentry/:menuid',
    name: 'glentry',
    component: () => import('../accounts/glentry/pagenewglentry.vue')
  },
  {
    path: '/editglentry/:menuid/:pkey/:val',
    name: 'editglentry',
    component: () => import('../accounts/glentry/pageeditglentry.vue')
  },
  {
    path: '/ap_new_entry',
    name: 'ap_new_entry',
    component: () => import('../accounts/ap/page_new_ap')
  },
  {
    path: '/ar_new_entry',
    name: 'ar_new_entry',
    component: () => import('../accounts/ar/page_new_ar')
  },
  {
    path: '/auth',
    name: 'uth',
    component: () => import('../role/auth')
  },
  
 
  {
    path: '/report_param_dna',
    name: 'report_param_dna',
    component: () => import('../reports/report_param_dna')
  },
 
  
  
  {
    path: '/view_pv/:reportname',
    name: 'view_pv',
    component: () => import('../reports/view_pv.vue')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error.vue')
  },
  {
    path: '/createdoc_pm',
    name: 'createdoc_pm',
    component: () => import('../accounts/ap/createdoc_payment_trans')
  }, 
  {
    path: '/paymentone',
    name: 'paymentone',
    component: () => import('../accounts/ap/createdoc_payment_trans_one')
  }, 
  {
    path: '/editdoc_pm/:menuid/:pkey/:val',
    name: 'editdoc_pm',
    component: () => import('../accounts/ap/editdoc_payment_trans')
  }, 
  {
    path: '/editdoc_one/:menuid/:pkey/:val',
    name: 'editdoc_one',
    component: () => import('../accounts/ap/edit_payment_trans_one')
  }, 

  {
    path: '/questions',
    name: 'questions',
    component: () => import('../question/feedquestion')
  }, 
  {
    path: '/newquestions',
    name: 'newquestions',
    component: () => import('../question/question')
  },
  {
    path: '/feednews',
    name: 'newquestions',
    component: () => import('../news/feednews')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../news/news')
  },
  {
    path: '/paymententry',
    name: 'paymententry',
    component: () => import('../accounts/ap/page_ap_entry')
  },
  // {
  //   path: '/submenu/:id',
  //   name: 'submenu',
  //   component: () => import('../views/submenu.vue')
  // },
  // {
  //   path: '/submenu1/:id',
  //   name: 'submenu',
  //   component: () => import('../views/submenu1.vue')
  // },
  //param_dailyreport
    {
      path: '/param_dailyreport',
      name: 'param_dailyreport',
      component: () => import('../reports/param_dailyreport')
    },

    {
      path: '/param_dailyreportd',
      name: 'param_dailyreportd',
      component: () => import('../reports/param_dailyreportd')
    },
    {
      path: '/param_dailyreportp',
      name: 'param_dailyreportp',
      component: () => import('../reports/param_dailyreportp')
    },

     {
      path: '/param_dailyreport_accd',
      name: 'param_dailyreport_accd',
      component: () => import('../reports/param_dailyreport_accd')
    },
    {
      path: '/param_dailyreportd_accd',
      name: 'param_dailyreportd_accd',
      component: () => import('../reports/param_dailyreportd_accd')
    },
    {
      path: '/param_dailyreportp_accd',
      name: 'param_dailyreportp_accd',
      component: () => import('../reports/param_dailyreportp_accd')
    },


    {
      path: '/param_times',
      name: 'param_times',
      component: () => import('../reports/param_times')
    },

    {
      path: '/view_dna_api/:apiname/:reportname',
      name: 'view_dna_api',
      component: () => import('../reports/view_dna_api')
    },

    {
      path: '/schools',
      name: 'schools',
      component: () => import('../school/list_schools.vue')
    },

  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/404.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  //  ${//to and from are Route Object,next() must be called to resolve the hook}
  //let iSlogin= store.state.Login.Auth_Login 
  let skip= to.query.auth
  let iSlogin = false
 
try {
    if(skip==null){
      let    Login = JSON.parse(localStorage.getItem('Login'))
         if (Login == null) {
          iSlogin = false
        } else {
          iSlogin = Login.Auth_Login
        }
    }else{
      iSlogin =  true
    }
   
   // console.log(Login.Auth_Login)
 
 
} catch (error) {
  iSlogin = false
 // console.log(error)
}


  //this.$store.setUsername(Login.username)

  //console.log(iSlogin)
  // if (to.meta.requiresAuth) {
  if (to.path != '/login') {
    if (iSlogin) {
      // console.log('There is a token, resume. (' + to.path + ')');
      next();
    } else {
      //  console.log('There is no token, redirect to login. (' + to.path + ')');
      next('login');
      // next('/login');
      // router.push('login');
    }
  } else {
    //  console.log('You\'re on the login page');
    if (iSlogin) {
      next('/');
    } else {
      next();
    }
  }

  next();





})


export default router
